export default "/images/vendor/flag-icons/flags/1x1/as.svg?0f89fa27cfed3543d1faf2dbd6019978";